import { render, staticRenderFns } from "./ImportUser.vue?vue&type=template&id=53cf8d4e&scoped=true&"
import script from "./ImportUser.vue?vue&type=script&lang=js&"
export * from "./ImportUser.vue?vue&type=script&lang=js&"
import style0 from "./ImportUser.vue?vue&type=style&index=0&id=53cf8d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cf8d4e",
  null
  
)

export default component.exports